module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0150.jpg?v=903474d1";